"use client";
import Link from 'next/link';
import styles from './styles.module.scss';

const SidebarSection = (props) => {
    const {headline, subheadlines} = props || {};

    const handleHeadlineClick = e => {
        e.preventDefault();
        const head = e.target.getAttribute('data-headline-link');
        const element = document.querySelector(`[data-headline-text="${head}"]`);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
    }

    const handleSubHeadlineClick = e => {
        e.preventDefault();
        const subhead = e.target.getAttribute('data-subhead-link');
        const element = document.querySelector(`[data-subhead-text="${subhead}"]`);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
    }

    const renderSubheads = () => {
        return subheadlines && subheadlines.map((subhead, index) => {
            return(
                <li key={index} className={styles.blogSidebar__subheadline}> 
                    <Link onClick={handleSubHeadlineClick} href="#" data-subhead-link={subhead}>
                        {subhead}
                    </Link>
                </li>
            );
        })
    }

    return(
        <div className={styles.blogSidebar__section}>
            <h3 onClick={handleHeadlineClick} className={`${styles.blogSidebar__headline}`} data-headline-link={headline}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g>
                        <path d="M20 13H13V20H11V13H4V11H11V4H13V11H20V13Z" fill="#E8236B"/>
                    </g>
                </svg>
                {headline}
            </h3>
            <ul>
                {renderSubheads()}
            </ul>
        </div>
    );
}
export default SidebarSection;